export const FileType = {
  photo: 'photo',
  zip: 'zip'
};
